<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
      :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'doctIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'doctname', fieldtype: 'C', title: '单据分类',calculExpr:'', addNewRowFlg: false},
          { field: 'menuname', fieldtype: 'C', title: '单据表单',calculExpr:'',addNewRowFlg: false},
          { field: 'methodname', fieldtype: 'C', title: '生成方法',calculExpr:'',addNewRowFlg: false},
          { field: 'lhcname', fieldtype: 'C',title: '物流处理码1',calculExpr:'',addNewRowFlg: false},
          { field: 'secondlhcname', fieldtype: 'C',title: '物流处理码2',calculExpr:'',addNewRowFlg: false},
          { field: 'thirdlhcname', fieldtype: 'C',title: '物流处理码3',calculExpr:'',addNewRowFlg: false},
          { field: 'doctremark', fieldtype: 'C',title: '备注',calculExpr:'',addNewRowFlg: false}
        ],
        doctform: false,
        doct: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addDoct())
      this.$on('CHG', () => this.chgDoct())
      this.$on('DEL', () => this.delDoct())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.doct = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addDoct () {
        let form = {
          doctid: 0
        }
        this.$router.push({name: 'doctForm', params: {form: form, type: 1}})
      },
      async chgDoct () {
        this.$router.push({name: 'doctForm', params: {form: this.doct, type: 1}})
      },
      async delDoct () {
        console.log(this.doct)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/doct/delDoct',
            method: "post",
            data: this.doct
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },

      search (target) {},
      async save () {
        await request({
          url: '/kfgl/doct/addOrEdit',
          method: "post",
          data: this.doct
        })
        this.$message.success('操作成功')
        this.doctform = false
        if (!this.doct.doctid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.doct = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/doct/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
